import { chainsRoutesConfig } from 'domains/chains/routes';
import { selectChainById } from 'modules/chains/store/selectors';
import { useAppSelector } from 'store/useAppSelector';
import { useFetchBlockchainsQuery } from 'modules/chains/actions/fetchBlockchains';
import { hasPublicSubchains } from 'modules/chains/utils/hasPublicSubchains';

const { useParams: useChainPageParams } = chainsRoutesConfig.chainDetails;

export const useChainInfo = () => {
  useFetchBlockchainsQuery();

  const { chainId: chainID } = useChainPageParams();

  const chain = useAppSelector(state => selectChainById(state, chainID));

  const isPublic = !chain || chain.isPublic || hasPublicSubchains(chain);
  const isPremiumOnly = Boolean(chain?.premiumOnly);

  return {
    isPremiumOnly,
    isPublic,
  };
};
